export default __webpack_public_path__ + "static/media/prodimg-mez-1.cfec91ea.png";